module.exports = __webpack_public_path__ + "media/images/narakyoto_th01-7569dba7b9083923610650d49028f719.jpg";